import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import Webcam from '../UserMedia/Webcam';
import EnrollPC from '../Enroll/EnrollPC';
import EnrollComplete from '../Enroll/EnrollComplete';
import * as icons from '../Icons/Icons';

const EnrollMobile = observer(class EnrollMobile extends React.Component {
  constructor() {
    super();
    this.ready = this.ready.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.complete = this.complete.bind(this);
  }

  componentWillMount() {
    this.state = {
      step: 1,
      ready: false,
      idFront: null,
      idBack: null,
      headshot: null,
      getUserMedia: true
    };

    // Check if getUserMedia is supported
    this.testGetUserMedia();
  }

  testGetUserMedia() {
    const _this = this;

    if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      // Safari on iOS (as of the 11 release) claims to support
      // getUserMedia but chokes the constraints for some reason
      // so we need to test setting up a stream and catch any errors
      const constraints = {
        audio: false,
        video: {
          width: window.innerWidth,
          height: window.innerHeight,
          facingMode: this.props.camera
        }
      };

      navigator.mediaDevices.getUserMedia(constraints)
        .catch(error => {
          // Basic setup threw an error, so it’s safe to assume
          // there’s not actually any support for getUserMedia
          _this.setState({
            getUserMedia: false
          });
        });
    } else {
      // Definitely not supported
      _this.setState({
        getUserMedia: false
      });
    }
  }

  ready() {
    this.setState({
      ready: true
    });

    const html = document.querySelector('html');
    html.className += ' fullscreen';

    const header = document.querySelector('.site-head--outside');
    header.className += ' site-head--fullscreen';
  }

  nextStep() {
    this.setState({
      step: this.state.step + 1,
      ready: false
    });

    const html = document.querySelector('html');
    html.className = html.className.replace('fullscreen', '');

    const header = document.querySelector('.site-head--outside');
    header.className = header.className.replace('site-head--fullscreen', '');
  }

  complete() {
    this.setState({
      step: 4
    });

    const html = document.querySelector('html');
    html.className = html.className.replace('fullscreen', '');

    const header = document.querySelector('.site-head--outside');
    header.className = header.className.replace('site-head--fullscreen', '');
  }

  render() {
    const { translation } = this.props;

    if(this.state.getUserMedia && this.state.step !== 4) {
      // If getUserMedia is supported, we can access the webcam and capture an image from that
      return(
        <main tabIndex="0" id="main-content" className="page--webcam">
          {!this.state.ready &&
            <div className="wrap">
              <div className="panel--brief">
                {this.state.step === 1 &&
                  <div className="copy-brief">
                    <h2 className="panel__title">{translation.id_front_heading}</h2>
                    <p>{translation.id_front}</p>
                  </div>
                }

                {this.state.step === 2 &&
                  <div className="copy-brief">
                    <h2 className="panel__title">{translation.id_back_heading}</h2>
                    <p>{translation.id_back}</p>
                  </div>
                }

                {this.state.step === 3 &&
                  <div className="copy-brief">
                    <h2 className="panel__title">{translation.headshot_heading}</h2>
                    <p>{translation.headshot}</p>
                  </div>
                }

                <button
                  className="btn btn--icn-right"
                  onClick={this.ready}
                >
                  {translation.continue}
                  <icons.iconCircleRight />
                </button>
              </div>
            </div>
          }

          {this.state.step === 1 && this.state.ready &&
            <Webcam
              allowCapture={true}
              name="idFront"
              camera="environment"
              type="landscape"
              parent={this}
              callback={this.nextStep}
              caption={translation.id_front_heading}
              {...this.props}
            />
          }

          {this.state.step === 2 && this.state.ready &&
            <Webcam
              allowCapture={true}
              name="idBack"
              camera="environment"
              type="landscape"
              parent={this}
              callback={this.nextStep}
              caption={translation.id_back_heading}
              {...this.props}
            />
          }

          {this.state.step === 3 && this.state.ready &&
            <Webcam
              allowCapture={true}
              name="headshot"
              camera="user"
              type="portrait"
              parent={this}
              callback={this.complete}
              caption={translation.headshot_heading}
              {...this.props}
            />
          }
        </main>
      );
    } else if(!this.state.getUserMedia && this.state.step !== 4) {
      // Otherwise, we’ll fall back to standard file inputs
      return (
        <main tabIndex="0" id="main-content" className="page wrap">
          <EnrollPC
            isMobile={true}
            complete={this.props.complete}
            {...this.props}
          />
        </main>
      )
    } else if(this.state.step === 4) {
      return (
        <main tabIndex="0" id="main-content" className="page wrap">
          <EnrollComplete {...this.props} />
        </main>
      )
    }

    return null;
  }
})

export default translate('EnrollMobile')(EnrollMobile);


// WEBPACK FOOTER //
// ./src/app/components/Enroll/EnrollMobile.js